import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-dialog',
    standalone: true,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        MatButtonModule,
        TranslocoModule,
    ],
    templateUrl: './confirm-dialog.component.html',
    styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmationDialogComponent {
    action: string = '';
    component: string = '';
    content: string = '';
    confirmButtonText = 'Yes';
    cancelButtonText = 'No';

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<ConfirmationDialogComponent>
    ) {
        if (data) {
            this.action = data.action || this.action;
            this.component = data.component || this.component;
            this.content = data.content || this.content;
            if (data.buttonText) {
                this.confirmButtonText =
                    data.buttonText.ok || this.confirmButtonText;
                this.cancelButtonText =
                    data.buttonText.cancel || this.cancelButtonText;
            }
        }
        //this.dialogRef.updateSize('300vw', '300vw');
    }

    onConfirmClick(): void {
        this.dialogRef.close(true);
    }
}
